<template>
    <div class="hljs-container" codetype="Java" v-code>
        <ul class="hljs-code-number">  
      <li v-for="(item, index) in numlist" :key="index">  
        {{ item+1 }}  
      </li>  
    </ul> 
        <highlightjs   :code="tocode" ></highlightjs>
    </div>
</template>

<script setup lang="ts">
import vCode from './line';
const props = defineProps({
    tocode: {
        type: String,
        default: '',
    },
    
})
let num = props.tocode.split('\n').length
let numlist = [...Array(num).keys()]




</script>

<style scoped lang="scss">
@import "./code.scss";
</style>
